import api from "../api";

const getSettings = async (workspaceId, key) => {
  return api
    .get(`/v0/user/${workspaceId}/settings`, { headers: { key: key } })
    .then((response) => response)
    .catch((error) => error.response);
};

const saveSettings = async (payload, workspaceId) => {
  return api
    .patch(`/v0/user/${workspaceId}/settings`, payload)
    .then((response) => response)
    .catch((error) => error.response);
};

export { getSettings, saveSettings };
